import { Button } from "@smart/itops-sb-design-system-dom";
import { useSmokeballApp } from "@smart/itops-smokeball-app-dom";

export const WindowCloser = () => {
  const { host, hostType } = useSmokeballApp();

  return (
    hostType !== "windows" && (
      <Button
        leftIcon="regularXmarkLarge"
        variant="secondarySubtle"
        onClick={() => host?.close()}
        dataTestId="builder-window-closer"
      />
    )
  );
};
